module.exports = __webpack_public_path__ + "static/Find Us Store 6-01-a6fee97b6a0b5e4aa8a22b268cee55bf.png";